export default "__VITE_ASSET__DdBlPItq__"